import React from "react";
import styled from "styled-components";
import SubscriptionCard from "./SubscriptionCard";
import { TypeAnimation } from "react-type-animation";

const CardContainer = styled.div`
  gap: 20px;
  display: flex;
  @media (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0px;
  }
`;

const subscriptionData = [
  {
    type: "Standard",
    price: "5,99 $",
    color: "#fdbb2d",
    description: [
      "15 participants / jeu.",
      "1 profil toyaloo.",
      "Expérience basic.",
      "Carte illimité pour les révisions des cours.",
      "10% de reduction aux events et produits toyaloo.",
      "Accès à 15 jeux par jour.",
    ],
    imageSrc:
      "./Assets/abonnement1.png",
  },
  {
    type: "Family",
    price: "9,99 $",
    color: "#CA30F5",
    description: [
      "20 participants / jeu.",
      "3 profil toyaloo.",
      "Expérience basic.",
      "Carte illimité pour les révisions des cours.",
      "10% de reduction aux events et produits toyaloo.",
      "Accès à 20 jeux par jour/profil.",
    ],
    imageSrc:
    "./Assets/abonnement3.jpg",
  },
  {
    type: "Premium",
    price: "14,99 $",
    color: "#59B1E6",
    description: [
      "50 participants / jeu.",
      "5 profil toyaloo.",
      "Expérience basic.",
      "Carte illimité pour les révisions des cours avec test (examination).",
      "30% de reduction aux events et produits toyaloo.",
      "Accès à tous les jeux.",
      "Création des Aloo.",
      "10 profils toyaloo corporate.",
    ],
    imageSrc:
    "./Assets/abonnement3.png",
  },
];

function SubscriptionSection() {
  return (
    <StoreContainer>
      <Header>
        <AnimatedHeading
          sequence={[
            "Abonnement ",
            1000,
            "Subscription ",
            1000,
            "Bokomi ",
            1000,
            "Usajili ",
            1000,
            "Kutitama ",
            1000,
            "Kikomama ",
            1000,
          ]}
          speed={50}
          repeat={Infinity}
        />
      </Header>
      <MainContent>
        <CardContainer>
          {subscriptionData.map((subscription, index) => (
            <SubscriptionCard key={index} {...subscription} />
          ))}
        </CardContainer>
      </MainContent>
    </StoreContainer>
  );
}

const StoreContainer = styled.main`
  border-radius: 16px;
  /* background: color(display-p3 1 1 1); */
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin: 10px;
`;

const AnimatedHeading = styled(TypeAnimation)`
  font-family: Poppins, sans-serif;
  font-size: 18px;
  color: color(display-p3 0.0783 0.0806 0.0842);
  font-weight: 600;
  line-height: 111%;
  font-feature-settings: "clig" off, "liga" off;

  @media (max-width: 991px) {
    max-width: 100%;
    padding-right: 20px;
    white-space: normal;
  }
`;

const MainContent = styled.section`
  display: flex;
  margin-top: 24px;
  flex-direction: column;
  padding: 0 0 30px 5px;

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

export default SubscriptionSection;
